import type { FederalState, HolidayRule } from '../domain/holidays';

// DE: Landesweite gesetzliche Feiertage (Stand 2026); lokale Feiertage tragen die Nutzer selbst ein.
// EN: Statewide public holidays (as of 2026); users add local holidays themselves.
// prettier-ignore
export const HOLIDAY_RULES: readonly HolidayRule[] = [
  { id: 'new-year', kind: 'fixed', month: 1, day: 1, states: 'all' },
  { id: 'epiphany', kind: 'fixed', month: 1, day: 6, states: ['BW', 'BY', 'ST'] },
  { id: 'womens-day', kind: 'fixed', month: 3, day: 8, states: ['BE', 'MV'] },
  { id: 'good-friday', kind: 'easter', offset: -2, states: 'all' },
  { id: 'easter-monday', kind: 'easter', offset: 1, states: 'all' },
  { id: 'labour-day', kind: 'fixed', month: 5, day: 1, states: 'all' },
  { id: 'ascension', kind: 'easter', offset: 39, states: 'all' },
  { id: 'whit-monday', kind: 'easter', offset: 50, states: 'all' },
  { id: 'corpus-christi', kind: 'easter', offset: 60, states: ['BW', 'BY', 'HE', 'NW', 'RP', 'SL'] },
  { id: 'assumption', kind: 'fixed', month: 8, day: 15, states: ['SL'] },
  { id: 'world-childrens-day', kind: 'fixed', month: 9, day: 20, states: ['TH'] },
  { id: 'unity-day', kind: 'fixed', month: 10, day: 3, states: 'all' },
  { id: 'reformation-day', kind: 'fixed', month: 10, day: 31, states: ['BB', 'HB', 'HH', 'MV', 'NI', 'SN', 'ST', 'SH', 'TH'] },
  { id: 'all-saints', kind: 'fixed', month: 11, day: 1, states: ['BW', 'BY', 'NW', 'RP', 'SL'] },
  { id: 'repentance-day', kind: 'repentance-day', states: ['SN'] },
  { id: 'christmas-day', kind: 'fixed', month: 12, day: 25, states: 'all' },
  { id: 'boxing-day', kind: 'fixed', month: 12, day: 26, states: 'all' },
];

// prettier-ignore
export const FEDERAL_STATES: readonly FederalState[] = [
  'BB', 'BE', 'BW', 'BY', 'HB', 'HE', 'HH', 'MV', 'NI', 'NW', 'RP', 'SH', 'SL', 'SN', 'ST', 'TH',
];
